import { render, staticRenderFns } from "./OrderListFiles/OrderList.html?vue&type=template&id=4be74566&scoped=true&external"
import script from "./OrderListFiles/OrderList.js?vue&type=script&lang=js&external"
export * from "./OrderListFiles/OrderList.js?vue&type=script&lang=js&external"
import style0 from "./OrderListFiles/OrderList.scss?vue&type=style&index=0&id=4be74566&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be74566",
  null
  
)

export default component.exports